import { useEffect, useState } from 'react';
import styles from '../../css/Select.module.css';

export default function SelectComponent({
  // state,
  // setState,
  nullData,
  checkedMenus,
  setCheckedMenus,
  checkedCodeMenus,
  setCheckedCodeMenus
}) {

  //데이터 불러오기
  let data = {};
  data['type'] = 'business';

  const [selectData, setSelectData] = useState([]);

  useEffect(() => {
    fetch("api/getCommonCode", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data })
    })
      .then(res => { return res.json() })

      .then(data => {
        Object.values(data).filter(item => {
          return setSelectData(item)
        })
      })

      .catch(error => console.log(error))
  }, [])

  //데이터 필터링
  const [selectList, setSelectList] = useState([]);

  useEffect(() => {
    const filteredList = selectData.filter(filtered => (
      filtered.value === nullData
    ));

    if (filteredList.length > 0) {
      setSelectList(filteredList[0].list);
    }

  }, [selectData, nullData]);

  // console.log(selectData)

  // checkbox onChange
  const handleCheckboxChange = (e, code) => {
    const value = e.target.value;

    const newCheckedMenus = checkedMenus.includes(value) ? checkedMenus.filter(menu => menu !== value) : [...checkedMenus, value];
    setCheckedMenus(newCheckedMenus);

    const newCodeArray = checkedCodeMenus.includes(code)? checkedCodeMenus.filter(menu => menu !== code) : [...checkedCodeMenus, code];
		setCheckedCodeMenus(newCodeArray);
  }

  const listSelected = checkedMenus.map((el, idx) => <li key={idx}>{el}</li>);

  return (
    <>
      <div className={styles.selectArea}>
        <div className={`${styles.title} ${styles.container}`}>
          <h2>상권분석 &gt; {nullData}</h2>
          <p>분석하실 메뉴를 선택해주세요(복수선택 가능)</p>
        </div>
        <div className={`${styles.listArray} ${styles.container}`}>
          <h2>선택된 상권</h2>
          <ul>
            {listSelected}
          </ul>
        </div>
        <div className={styles.scroll}>
          <ul>
            {
              selectList.map((menu, code) => (
                <li key={code}>
                  <input type='checkbox'
                    id={menu.code}
                    name='menu'
                    value={menu.value}
                    onChange={(e) => handleCheckboxChange(e, menu.code)}
                  />
                  <label htmlFor={menu.code}>
                    <img src='img/icon_plus.png' alt='icon' />
                    {menu.value}
                  </label>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    </>
  )
}